import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.error('Error caught by boundary:', error, errorInfo);
    }
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--bg)',
          color: 'var(--fg)',
          fontFamily: 'var(--mono)',
          padding: '2rem',
        }}>
          <div style={{ maxWidth: '520px', textAlign: 'center' }}>
            <div style={{ color: 'var(--fg-dim)', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
              $ ./portfolio
            </div>
            <h1 style={{ color: 'var(--fg-bright)', fontSize: '1.5rem', margin: '0 0 1rem 0' }}>
              segmentation fault (core dumped)
            </h1>
            <p style={{ color: 'var(--fg-muted)', margin: '0 0 1.5rem 0' }}>
              Something went wrong. Please refresh the page.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="term-btn term-btn-primary"
            >
              reload
            </button>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={{ marginTop: '1.5rem', textAlign: 'left' }}>
                <summary style={{ cursor: 'pointer', color: 'var(--fg-muted)' }}>
                  error details (development)
                </summary>
                <pre style={{
                  marginTop: '0.5rem',
                  padding: '1rem',
                  background: 'var(--bg-elev)',
                  border: '1px solid var(--border)',
                  fontSize: '0.78rem',
                  color: 'var(--fg)',
                  overflow: 'auto',
                  whiteSpace: 'pre-wrap',
                }}>
                  {String(this.state.error)}
                  {this.state.errorInfo && '\n' + this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
